// Chakra Imports
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Link,
  Text,
  useColorModeValue,
  Avatar,
  Image,
  IconButton,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import AdminNavbarLinks from "components/navbar/NavbarLinksAdmin";
import { SidebarResponsive } from "components/sidebar/Sidebar";
import { SidebarContext } from "contexts/SidebarContext";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import logo from "assets/img/P.jpeg";


export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);
  const { sidebarCollapsed, setSidebarCollapsed } = useContext(SidebarContext);
  const history = useHistory();

  const userData = localStorage.getItem("user");
  const userName = userData ? JSON.parse(userData).name : "User";

  useEffect(() => {
    window.addEventListener("scroll", changeNavbar);

    return () => {
      window.removeEventListener("scroll", changeNavbar);
    };
  });

  const { secondary, message, brandText } = props;

  // Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
  let mainText = useColorModeValue("navy.700", "white");
  let secondaryText = useColorModeValue("gray.700", "white");
  let navbarPosition = "fixed";
  let navbarFilter = "none";
  let navbarBackdrop = "blur(20px)";
  let navbarShadow = "none";
  let navbarBg = useColorModeValue(
    // "rgba(244, 247, 254, 0.2)",
    // "rgba(11,20,55,0.5)"
    "rgba(244, 247, 254, 1)",
    "rgba(11,20,55,1)"
  );
  let navbarBorder = "transparent";
  let secondaryMargin = "0px";
  let paddingX = "15px";
  let gap = "0px";
  const changeNavbar = () => {
    if (window.scrollY > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  return (
    <Box
      position={navbarPosition}
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      backgroundPosition='center'
      backgroundSize='cover'
      // borderRadius='16px'
      borderRadius='0px'
      borderWidth='1.5px'
      borderStyle='solid'
      transitionDelay='0s, 0s, 0s, 0s'
      transitionDuration=' 0.25s, 0.25s, 0.25s, 0s'
      transition-property='box-shadow, background-color, filter, border'
      transitionTimingFunction='linear, linear, linear, linear'
      alignItems={{ xl: "center" }}
      display={secondary ? "block" : "flex"}
      minH='75px'
      justifyContent={{ xl: "center" }}
      lineHeight='25.6px'
      mx='auto'
      mt={secondaryMargin}
      pb='8px'
      // right={{ base: "12px", md: "30px", lg: "30px", xl: "30px" }}
      // right={{ base: "0px", md: "0px", lg: "0px", xl: "0px" }}
      right="0px"
      left="0px"
      px={{
        sm: paddingX,
        md: "10px",
      }}
      ps={{
        xl: "12px",
      }}
      pt='8px'
      // top={{ base: "12px", md: "16px", xl: "18px" }}
      top='0px'
      // w={{
        // base: "calc(100vw - 6%)",
        // md: "calc(100vw - 8%)",
        // lg: "calc(100vw - 6%)",
        // xl: "calc(100vw - 350px)",
        // "2xl": "calc(100vw - 365px)",
      //   base: "100%",
      //   xl: "calc(100% - 290px)",
      // }}>
      w="100%"
      zIndex='1100'>
      <Flex
        w='100%'
        // flexDirection={{
        //   sm: "column",
        //   md: "row",
        // }}
        // alignItems={{ xl: "center" }}
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="nowrap"
        bg={useColorModeValue("white", "navy.800")}
        // borderRadius='30px'
        // boxShadow={useColorModeValue(
        //   "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
        //   "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
        // )}
        // p='10px'
        // mb={gap}>
        borderRadius='16px'
        p='10px 20px'
        borderBottom="1px solid"
        borderColor={useColorModeValue("gray.100", "whiteAlpha.100")}
      >
        {/* <Box mb={{ sm: "8px", md: "0px" }}> */}
        {/* <Box mb={{ sm: "8px", md: "0px" }} ps='15px'> */}
        {/* <SidebarResponsive routes={props.routes} /> */}
        {/* <Box mb={{ sm: "8px", md: "0px" }} ps='5px'>
          <Breadcrumb> */}
        {/* <Flex align="center" flexShrink={1} overflow="hidden">
          <Flex align="center" display={{ base: "flex", xl: "none" }} pe="10px">
          <Avatar src={logo} w="32px" h="32px" borderRadius="50%" />
        </Flex> */}
        <Flex align="center" flexShrink={0}>
          <Image 
            // src="./prowess-logo.png" 
            src={useColorModeValue("./prowess-logo.png", "./prowess-logo.png")} 
            display={{ base: "none", xl: "block" }}
            h="40px" 
            ms="0px" 
            me="15px" 
            alt="PROWESS ERP Logo" 
          />
          <Image 
            src={logo}
            display={{ base: "block", xl: "none" }}
            h="40px" 
            w="40px"
            borderRadius="50%"
            objectFit="cover"
            ms="0px" 
            me="10px" 
            alt="PROWESS ERP Mobile Logo" 
          />
          {/* Desktop sidebar toggle — hidden on mobile */}
          {/* <IconButton
            display={{ base: "none", xl: "flex" }}
            aria-label="Toggle Sidebar"
            icon={sidebarCollapsed ? <HamburgerIcon /> : <CloseIcon />}
            size="sm"
            variant="ghost"
            colorScheme="gray"
            me="10px"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          /> */}
          <IconButton
  display={{ base: "none", xl: "flex" }}
  aria-label="Toggle Sidebar"
  icon={
    <HamburgerIcon
      transform={sidebarCollapsed ? "rotate(0deg)" : "rotate(90deg)"}
      transition="0.2s"
    />
  }
  size="sm"
  variant="ghost"
  colorScheme="gray"
  me="10px"
  onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
/>
          <Box me="10px">
            <SidebarResponsive routes={props.routes} />
          </Box>
        </Flex>
          {/* <SidebarResponsive routes={props.routes} /> */}
          {/* <Box ps='5px' flexShrink={1} overflow="hidden"> */}
          {/* <Box ps='5px' flexShrink={1} overflow="hidden" minW={0}>
            <Breadcrumb whiteSpace="nowrap">
            <BreadcrumbItem color={secondaryText} fontSize='xs'> */}
          <Box ps='5px' flexShrink={1} overflow="hidden" minW={0} maxW={{ base: "120px", md: "unset" }}>
          <Breadcrumb 
            whiteSpace="nowrap"
            separator="/"
            spacing={{ base: "1", md: "2" }}
          >
            <BreadcrumbItem color={secondaryText} fontSize={{ base: "xs", md: "md" }}>
              {/* <BreadcrumbLink  color={secondaryText} */}
              <BreadcrumbLink 
                color={useColorModeValue("brand.500", "white")}
                fontWeight='semibold'
                // letterSpacing='0.2px'>
                letterSpacing='0.2px'
                  isTruncated
                  // maxW={{ base: "80px", md: "200px", lg: "unset" }}>
                  maxW={{ base: "50px", md: "unset" }}
                  onClick={() => history.push("/admin/dashboard")}
                  cursor="pointer"
                  _hover={{ textDecoration: "underline" }}
              >
                Home
              </BreadcrumbLink>
            </BreadcrumbItem>

            {/* <BreadcrumbItem color={secondaryText} fontSize='sm'>
              <BreadcrumbLink color={secondaryText}>
                {brandText}
              </BreadcrumbLink>
            </BreadcrumbItem> */}
            {/* <BreadcrumbItem color={secondaryText} fontSize='xs'> */}
            <BreadcrumbItem color={secondaryText} fontSize={{ base: "xs", md: "md" }}>
              <BreadcrumbLink
                color={secondaryText}
                fontWeight='semibold'
                letterSpacing='0.2px'
                isTruncated
                  // maxW={{ base: "120px", md: "300px", lg: "unset" }}
                maxW={{ base: "70px", md: "unset" }}
              >
                {brandText}
              </BreadcrumbLink>
            </BreadcrumbItem>

          </Breadcrumb>
          {/* <Link
            color={mainText}
            href='#'
            bg='inherit'
            borderRadius='inherit'
            fontWeight='bold'
            fontSize='34px'
            _hover={{ color: { mainText } }}
            _active={{
              bg: "inherit",
              transform: "none",
              borderColor: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}>
            {brandText}
            </Link> */}
          </Box>
        {/* <Box ms='auto' w={{ sm: "100%", md: "unset" }}> */}
        {/* </Flex> */}
        <Box ms='auto' w="auto">
          <AdminNavbarLinks
            onOpen={props.onOpen}
            logoText={props.logoText}
            secondary={props.secondary}
            fixed={props.fixed}
            scrolled={scrolled}
            routes={props.routes}
          />
        </Box>
      </Flex>
      {secondary ? <Text color='white'>{message}</Text> : null}
    </Box>
  );
}

AdminNavbar.propTypes = {
  brandText: PropTypes.string,
  variant: PropTypes.string,
  secondary: PropTypes.bool,
  fixed: PropTypes.bool,
  onOpen: PropTypes.func,
};
